const getLatLong = (address) => {
  const encodedAddress = encodeURIComponent(address);
  return fetch('https://atlas.microsoft.com/search/address/json?api-version=1.0&query='
  + encodedAddress + '&subscription-key=' + process.env.REACT_APP_AZURE_MAPS_API_KEY)
};

export default {
  getLatLong,
};